<template>
  <div class="webboard-create-page">
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex align-center">
        <Iconify
          icon="iconamoon:comment-add"
          color="var(--theme-color-seven)"
          size="30px"
          class="mr-2 create-icon"
        />
        <div class="page-title">ตั้งกระทู้ใหม่</div>
      </div>
    </div>

    <v-form ref="form" v-model="valid" lazy-validation>
      <divcard class="mt-3 create-card">
        <div class="d-flex align-center mb-3">
          <Iconify
            icon="mdi:text-box-edit-outline"
            color="var(--theme-color-one)"
            class="mr-2"
          />
          <div class="font-20 font-w-700 create-section-title">
            รายละเอียดกระทู้ใหม่
          </div>
        </div>

        <div class="d-flex flex-column gap-14">
          <div class="flex">
            <div class="mb-1 black--text">
              หัวข้อ
              <span class="theme-color-seven txt-normal">*</span>
            </div>
            <TextField
              theme="3"
              :value="form.title"
              placeholder="ตั้งหัวข้อ"
              :rules="[
                (v) => !!v || 'กรุณาระบุหัวข้อ',
                (v) => (v && v.length <= 255) || 'หัวข้อต้องไม่เกิน 255 ตัวอักษร'
              ]"
              @onChange="setFormField('title', $event)"
            />
          </div>

          <div class="flex">
            <div class="mb-1 black--text">
              รายละเอียด
              <span class="theme-color-seven txt-normal">*</span>
            </div>
            <div class="editor-frame">
              <Wysiwyg
                :value="form.content"
                height="220px"
                @onChange="setFormField('content', $event)"
              />
            </div>
          </div>
        </div>
      </divcard>
    </v-form>

    <div class="d-flex justify-space-between mt-5">
      <div>
        <Button theme="2" @onClick="routeBack">ยกเลิก</Button>
      </div>
      <div>
        <Button :loading="loading" theme="1" @onClick="saveTopic">บันทึก</Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/input/Button";
import TextField from "@/components/input/TextField.vue";
import Wysiwyg from "@/components/input/Wysiwyg.vue";

export default {
  name: "WebboardCreate",
  components: {
    Button,
    TextField,
    Wysiwyg,
  },
  data() {
    return {
      valid: true,
      loading: false,
      form: {
        title: "",
        content: "",
      },
    };
  },
  methods: {
    setFormField(key, value) {
      this.form[key] = value;
    },
    hasMeaningfulContent(content) {
      const html = (content || "").trim();

      if (!html) return false;

      const textOnly = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
      const hasMedia = /<(img|video|iframe|embed|object|audio)\b/i.test(html);

      return Boolean(textOnly || hasMedia);
    },
    routeBack() {
      this.$router.push({ name: "Webboard" });
    },
    async saveTopic() {
      const isValid = this.$refs.form.validate();

      if (!isValid) return;

      if (!this.hasMeaningfulContent(this.form.content)) {
        this.$store.commit("General/setModal", {
          title: "ข้อมูลไม่ถูกต้อง",
          text: "กรุณาระบุรายละเอียด",
          buttonText: "ตกลง",
          showCancel: false,
          theme: "warning",
        });
        return;
      }

      this.loading = true;
      const res = await this.$apiFire("Webboard/save", this.form);
      this.loading = false;

      if (!res) return;

      this.$router.push({ name: "Webboard" });
    },
  },
};
</script>

<style scoped lang="scss">
.webboard-create-page {
  min-height: calc(100vh - var(--header-height));
}

.create-card {
  padding: 20px 24px !important;
}

.create-section-title {
  color: var(--theme-color-one);
}

.editor-frame {
  border: 1px solid var(--theme-color-nine);
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
}

@media (max-width: 1280px) {
  .create-card {
    padding: 18px 20px !important;
  }
}
</style>
